import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopSelectedProjectDifficultyLevel, selectCoopSelectedProjectType, } from "../../../selectors/selectCoopInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { DialogWrapper } from "../../dialog/DialogWrapper";
import { ButtonConfirmation } from "../../generic/common/ButtonConfirmation";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionCoopProjectStart } from "../actionCoop";
var _DialogCoopProjectStartConfirmation = function (_a) {
    var selectedCoopProject = _a.selectedCoopProject, selectedCoopProjectDifficultyLevel = _a.selectedCoopProjectDifficultyLevel, onConfirmation = _a.onConfirmation, onCancel = _a.onCancel;
    var locaReplacements = new Map([
        [ReplacementLoca.zero_0, utilLoca.get(selectedCoopProject.locakey)],
        [ReplacementLoca.one_1, utilNumber.format(selectedCoopProjectDifficultyLevel)],
    ]);
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.startProjectConfirmation_title, onClose: onCancel, className: IdStyles.ModalBackgroundResources },
        React.createElement("div", { className: "dialog-coop__confirmation" },
            React.createElement(TextLoca, { className: IdStyles.TextNormal, id: IdLoca.startProjectConfirmation_desc, replacements: locaReplacements }),
            React.createElement(ButtonConfirmation, { onClickCancel: onCancel, onClickConfirm: function () {
                    return onConfirmation(selectedCoopProject.id, selectedCoopProjectDifficultyLevel);
                } }))));
};
var mapState = function (state) { return ({
    selectedCoopProject: selectCoopSelectedProjectType(state),
    selectedCoopProjectDifficultyLevel: selectCoopSelectedProjectDifficultyLevel(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onCancel: function () { return dispatch(actionModalClose(IdModal.CoopProjectStartConfirm)); },
    onConfirmation: function (projectTypeId, difficulty) {
        dispatch(actionCoopProjectStart(projectTypeId, difficulty));
        dispatch(actionModalClose(IdModal.CoopProjectStartConfirm));
    },
}); };
export var DialogCoopProjectStartConfirmation = connect(mapState, mapDispatch)(_DialogCoopProjectStartConfirmation);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/DialogCoopProjectStartConfirmation.tsx
// module id = 2811
// module chunks = 3